import { ArrowRightCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import AccessibilityGrid from './AccessibilityGrid';
import '../styles/Hero.scss';

const Hero = () => {
  return (
    <section id="home" className="hero2" aria-labelledby="hero-heading">
      <div className="hero2__bg-gradient"></div>
      <div className="hero2__bg-overlay"></div>

      <div className="hero2__container">
        <div className="hero2__content">
          <div className="hero2__text-content">
            <header>
              <h1 id="hero-heading" className="hero2__title">
                Get Your <br />
                <span className="hero2__title-accent">Accessibility</span>
                <br />
                Audit Report
              </h1>
              <h2 className="hero2__subtitle">
                Powered by <span className="hero2__subtitle-accent">Accessi Bridge AI</span>
              </h2>
            </header>
            <p className="hero2__description">
              Ensure your website's digital accessibility with Accessi Bridge, a powerful AI-enhanced tool that scans
              websites for compliance with EAA, BFSG and WCAG standards.
            </p>
            <div className="hero2__cta-wrapper" role="navigation" aria-label="Call to action">
              <Link to="/report" className="hero2__cta-primary">
                GET FREE AUDIT REPORT
                <ArrowRightCircle className="hero2__cta-icon" aria-hidden="true" />
              </Link>
              <Link to="/pricing" className="hero2__cta-secondary">
                VIEW PRICING PLANS
                <ArrowRightCircle className="hero2__cta-icon" aria-hidden="true" />
              </Link>
            </div>
          </div>
          <div className="hero2__image-container">
            <AccessibilityGrid />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
